import { render } from "./AbtestListPage.vue?vue&type=template&id=2a906719"
import script from "./AbtestListPage.vue?vue&type=script&lang=js"
export * from "./AbtestListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__